import React, { useEffect, useState } from "react";
import { InputAnswerAreaForLetters } from "./StyledComponent";
import Button from "components/Button";

const ResolutionProbleme = ({ item, consigneValues, setConsigneValues, handleAddWord }) => {
    const [loading, setLoading] = useState(false);

    // Initialize consigneValues based on item.correction_dp
    useEffect(() => {
        if (item?.correction_dp) {
            const initializedValues = item.correction_dp.map((step, index) => ({
                value: step,
                userValue: consigneValues[index]?.userValue || "", // Preserve existing userValue if present
            }));
            setConsigneValues(initializedValues);
        }
    }, [item, setConsigneValues]);

    // Handle input change
    const handleInputChange = (e, index) => {
        const value = e.target.value;
        const updatedValues = [...consigneValues];
        updatedValues[index] = {
            ...updatedValues[index],
            userValue: value,
        };
        setConsigneValues(updatedValues);
        console.log(`Input at index ${index} changed to: ${value}`);
    };

    return (
        <div>
            <p>{item?.consigne[0]}</p>
            <div className="flex-row mt-5">
                <p className="py-4 font-bold">Saisir les opérations qui permettent de résoudre le problème :</p>
                {item.correction_dp.map((step, index) => (
                    <InputAnswerAreaForLetters
                        key={index}
                        value={consigneValues[index]?.userValue || ""}
                        onChange={(e) => handleInputChange(e, index)}
                        placeholder="10 + 20 = 30"
                        className="mr-4 mb-2"
                    />
                ))}
            </div>
        </div>
    );
};

export default ResolutionProbleme;
